//打开页面
function pushPage() {
    invokeApp("page", {action: "push", path: "page/about"});
}
//关闭页面, 并把args内容返回上一个页面
function finishPage() {
    invokeApp("page", {action: "finish", args: {"data": "from result html"}});
}
//打开web网页
function pushWebAbout() {
    invokeApp("page", {
        action: "push",
        path: "page/webview",
        args: {url: "http://rabbit.voxcoo.com/#/regard", title: "关于"}
    });
}
///发送短信
function sendSMS() {
    invokeApp("sms", {number: "106981630163222", body: "测试短信222"});
}
//刷新页面数据
function refreshPage() {
    invokeApp('refresh', {pages: ["page/me/index", "page/console/index"]});
}


//隐藏appbar
function hideAppBar() {
    invokeApp("config", {showAppBar: false});
}

function call() {
    invokeApp("call", {number: "13149914326", name: "jjyo", type: 0});
}

function pay() {
    invokeApp("pay", {type: "alipay", info: "8F79CF08-A69C-4472-AD0A-DE0BD595C686"});
}

///显示, 配置appbar
function configAppBar() {
    invokeApp("config", {
        showAppBar: true,
        appBarColor: 0xffff0000,
        canPop: false,
        titleColor: 0xff00ff00,
        backgroundColor: 0xff0000ff,
        backItem: {type: "icon", data: "https://img.icons8.com/ios/50/000000/search--v1.png", event: "search"},
        actionItems: [
            {type: "text", data: "添加", event: "add"},
            {type: "text", data: "筛选", event: "filter"}
        ]
    });
}


//配置页面

//原生回调
// function callbackApp(message) {
//     console.log('appcallback')
//     jsonString = decodeURIComponent(message);

// }

//调用原生方法  
// function invokeApp(method, data) {
//     const str = navigator.userAgent;
//     if (str.includes('JyApp')) {
//         JyApp.postMessage(JSON.stringify({method: method, data: data}));
//     }
// }



export default {
    
    install(Vue,options){
        //调用原生方法
        Vue.prototype.invokeApp = function (method, data) {
            const str = navigator.userAgent;
            if (str.includes('JyApp')) {
                JyApp.postMessage(JSON.stringify({method: method, data: data}));
            }
        }
        //原生回调
        Vue.prototype.callbackApp = function (message){
            jsonString = decodeURIComponent(message);
        }
    }

}


// WEBPACK FOOTER //
// ./src/assets/js/conmon.js